module.exports = __webpack_public_path__ + "static/media/shopify13.d7877030.png";